import {
    GET_CONFIG,
    CHECK_REG_CODE,
    AUTHENTICATE,
    GENERIC_ERROR,
    INVALID_ERROR
} from '../actions/activationActions';

export const initialState = {
    config: {},
    regCode: {},
    authenticate: {},
    genericError: '',
    invalidError: ''
};

export default function activationReducer(state = initialState, action) {
    switch (action.type) {
        case GET_CONFIG:
            return {
                ...state,
                config: {
                    mvpd: action.mvpd,
                    message: action.message
                }
            };
        case CHECK_REG_CODE:
            return {
                ...state,
                regCode: {
                    code: action.code,
                    provider: action.provider,
                    mvpd: action.mvpd,
                    deviceType: action.deviceType,
                    message: action.message
                }
            };
        case AUTHENTICATE:
            return {
                ...state,
                authenticate: {
                    authUrl: action.authUrl,
                    authSuccessUrl: action.authSuccessUrl,
                    authErrorUrl: action.authErrorUrl,
                    useIframe: action.useIframe
                }
            };
        case GENERIC_ERROR:
            return {
                ...state,
                genericError: action.message
            };
        case INVALID_ERROR:
            return {
                ...state,
                invalidError: action.message
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/common/reducers/activationReducer.js